<template>
  <div>
    <BaseButton danger @click="setShow(true)"> Delete sms campaign </BaseButton>
    <Portal v-if="show" to="app-dialog">
      <VModal ref="modal" @modal:hidden="setShow(false)" disable-backdrop-click>
        <BaseVeeForm
          :action="destroySmsCampaign"
          v-slot="{ isPending, isRejected, invalid }"
          class="mx-auto max-w-lg"
        >
          <BaseCard @click.stop>
            <BaseCardHeader> Delete campaign </BaseCardHeader>
            <BaseCardBody>
              <p class="text-gray-600 mb-4">
                Are you sure you want to delete this campaign? Once a campaign is deleted, all
                related resources will also be deleted.
              </p>
            </BaseCardBody>
            <BaseCardFooter gray>
              <div class="flex space-x-2">
                <BaseButton primary :disabled="isPending || isRejected || invalid">
                  Delete campaign
                </BaseButton>
                <BaseButton type="button" ghost @click="setShow(false)"> Cancel </BaseButton>
              </div>
            </BaseCardFooter>
          </BaseCard>
        </BaseVeeForm>
      </VModal>
    </Portal>
  </div>
</template>

<script>
import { smsCampaignsClient } from '@/api/clients';

const props = {
  smsCampaignId: {
    type: String,
    required: true,
  },
};

function data() {
  return {
    show: false,
  };
}

const methods = {
  setShow(value) {
    this.show = Boolean(value);
  },
  async destroySmsCampaign() {
    try {
      await smsCampaignsClient.destroy(this.smsCampaignId);

      this.setShow(false);

      this.$router.replace({
        name: 'accounts.accountId.smsCampaigns',
        params: {
          accountId: this.$route.params.accountId,
        },
        query: {
          updated: new Date().getTime(),
        },
      });

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  props,
  data,
  methods,
};
</script>
